export default "__VITE_ASSET__BuWT5khc__"